/* eslint-disable */
import React, { PureComponent, Fragment } from 'react';
import css from './ElTiempo.style';

class ElTiempoHeader extends PureComponent {
  onBack = () => {
    if (document.referrer.indexOf("eltiempo.es") !== -1) {
      window.history.back();
    } else {
      window.location.href = "https://viajes.eltiempo.es/";
    }
    return false;
  };

  render() {
    const { onBack } = this;
    return (
      <Fragment>
        <header className="m1">
          <div className="m1_c">
            <div className="m1_r">
              <p className="c3">
                <a href="https://www.eltiempo.es/" onClick={onBack}>
                  <i className="icon-back" />
                </a>
              </p>
              <p className="c1">
                <a href="https://www.eltiempo.es/">
                  <img src="https://imgs-akamai.mnstatic.com/misc/eltiempo/logo.png" alt="Logo Eltiempo.es" />
                </a>
              </p>
            </div>
          </div>
        </header>
        <style type="text/css">{ css }</style>
      </Fragment>
    );
  }
}

export default ElTiempoHeader;
